export default __webpack_public_path__ + "static/media/Background_00131.56797ca5.png";